<div class="ion-page modal-body fixed" scrollY="true">
  <div class="modalInnerWrapper modal-content">
    <div class="modal-body text-center">

      <div class="">
        <div class="steps">
          <div class="steps-item steps-item-wait active" (click)="goto_step1()">
            <div class="steps-icon">
              <span class="icon-profile"></span></div>
          </div>
          <div class="steps-item steps-item-wait"  (click)="top_goto_step2($event)" [ngClass]="{'active':step2 || step3 || step4}">
            <div class="steps-icon">
              <span class="icon-location"></span></div>
          </div>
          <div class="steps-item steps-item-wait" (click)="top_goto_step3()" [ngClass]="{'active':step3 || step4}" >
            <div class="steps-icon">
              <span class="icon-password"></span></div>
          </div>
          <div class="steps-item steps-item-wait" (click)="top_goto_step4()" [ngClass]="{'active':step4}">
            <div class="steps-icon">
              <span class="icon-ok"></span></div>
          </div>
        </div>

        <div class="register-modal-form" *ngIf="step1">
          <form [formGroup]="regform" >
            <div class="text-center">
              <h4 class="t-h4 t-medium">{{ 'MODALS.REGISTRATION.TITLE' | translate }}</h4>
              <div class="t t-small">{{ 'MODALS.REGISTRATION.STEP_1' | translate }}: {{ 'MODALS.REGISTRATION.PERSONAL_INFORMATION'
                | translate }}</div>
            </div>
            <div class="mt-4 text-left">
              <div class="mb-3 position-relative">
                <label for="country_of_origin" class="form-label">{{ 'MODALS.REGISTRATION.COUNTRY_OF_ORIGIN' | translate
                  }}</label>
          
                <a href="#" class="btn btn-secondary btn-block text-left dropdown-toggle-chevron" data-toggle="dropdown"
                  data-target="dropdown1">
                  <img #flug class="icon" src="../../../assets/images/sri-lanka.png" alt="UK"> <span #countryname>{{ 'MODALS.REGISTRATION.COUNTRY_SRILANKA' | translate }}</span>
                </a>
                <ul id="dropdown1" class="dropdown-menu outline-white">
                  <li>
                    <a class="dropdown-item with-icon" (click)="click_lanka()">
                      <img class="icon" src="../../../assets/images/sri-lanka.png" alt="SriLanka"> {{ 'MODALS.REGISTRATION.COUNTRY_SRILANKA' | translate }}
                    </a>
                  </li>
                  <!-- <li>
                            <a class="dropdown-item with-icon"  (click)="click_china()">
                              <img class="icon" src="../../../assets/images/china.png" alt="China"> China
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item with-icon" (click)="click_france()" >
                              <img class="icon" src="../../../assets/images/france.png" alt="France"> France
                            </a>
                          </li>
                          <li>
                            <a class="dropdown-item with-icon" (click)="click_germany()" >
                              <img class="icon" src="../../../assets/images/germany.png" alt="Germany"> Germany
                            </a>
                          </li> -->
                </ul>
              </div>
              <div class="mb-3 d-inline-flex w-100">
                <div class="col-2 mr-4">
                  <label for="register_title" class="form-label">{{ 'MODALS.REGISTRATION.TITLE2' | translate }}</label>
                  <select class="form-control" [(ngModel)]="title" [ngModelOptions]="{standalone: true}">
                    <option>Mrs</option>
                    <option>Mr</option>
                  </select>
                </div>
                <div class="col-10">
                  <label for="register_first_name" class="form-label">{{ 'MODALS.REGISTRATION.FIRST_NAME' | translate }}</label>
                  <input formControlName="fname" required type="text" id="register_first_name" class="form-control"  [(ngModel)]="firstName"
                   placeholder="{{'PLACEHOLDERS.FNAME' | translate}}"  />

                  <span class="text-danger error " *ngIf="errorControl.fname.errors?.required && (errorControl.fname.dirty || errorControl.fname.touched)">
                    {{'FORM_ERR.FNAME_REQ' | translate}}
                  </span>
                  <span class="text-danger error " *ngIf="errorControl.fname.errors?.pattern && !errorControl.fname.errors?.maxlength && !errorControl.fname.errors?.minlength">
                    {{'FORM_ERR.FNAME_INVALID' | translate}}
                  </span>
                  <!-- <span class="text-danger error " *ngIf="errorControl.fname.errors?.minlength">
                    {{'FORM_ERR.FNAME_MIN' | translate}}
                  </span>
                  <span class="text-danger error " *ngIf="errorControl.fname.errors?.maxlength">
                    {{'FORM_ERR.FNAME_MAX' | translate}}
                  </span> -->
                </div>

              </div>
              <div class="mb-3">
                <label for="register_surname" class="form-label">{{ 'MODALS.REGISTRATION.SURNAME' | translate }}</label>
                <input formControlName="sname" type="text" id="register_surname" class="form-control" value="Smith" [(ngModel)]="surname"
                 placeholder="{{'PLACEHOLDERS.SNAME' | translate}}" />

                <span class="text-danger error " *ngIf="errorControl.sname.errors?.required && (errorControl.sname.dirty || errorControl.sname.touched)">
                  {{'FORM_ERR.SNAME_REQ' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl.sname.errors?.pattern && !errorControl.sname.errors?.minlength">
                  {{'FORM_ERR.SNAME_INVALID' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl.sname.errors?.minlength">
                  {{'FORM_ERR.FNAME_MIN' | translate}}
                </span>

              </div>
              <div class="mb-4">
                <label for="register_nic" class="form-label">{{ 'MODALS.REGISTRATION.NIC' | translate }}</label>
                <input type="number" id="register_nic" class="form-control" placeholder="{{'PLACEHOLDERS.NIC' | translate}}" [(ngModel)]="idNumber" 
                formControlName="nic"  />

                <span class="text-danger error " *ngIf="errorControl.nic.errors?.required && (errorControl.nic.dirty || errorControl.nic.touched)">
                  {{'FORM_ERR.NIC_REQ' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl.nic.errors?.pattern">
                  {{'FORM_ERR.NIC_MIN' | translate}}
                </span>
              </div>

              <!-- <div class="mb-4 position-relative nic-upload">
                <label class="form-label">{{ 'MODALS.REGISTRATION.NIC_FRONT_IMG' | translate }}</label>
              
                <input
                  #nicFrontInput
                  type="file"
                  accept="image/*"
                  capture="environment"
                  class="form-control"
                  hidden
                  (change)="onNicFrontSelected($event)"
                />

                <div
                  class="camera-box"
                  *ngIf="!nicFrontPreview"
                  (click)="nicFrontInput.click()"
                >
                  <ion-icon name="camera"></ion-icon>
                  <span style="text-align: center;">{{ 'MODALS.REGISTRATION.UPLOAD_NIC_FRONT' | translate }}</span>
                </div>

                <div class="text-danger error"
                    *ngIf="regform.get('nicFront')?.invalid && regform.get('nicFront')?.touched">
                  {{'FORM_ERR.NIC_FRONT' | translate}}
                </div>

                <div class="text-danger error"
                    *ngIf="regform.get('nicFront')?.hasError('conversionFailed') &&
                            regform.get('nicFront')?.touched">
                  {{ 'FORM_ERR.NIC_IMAGE_CONVERSION' | translate }}
                </div>
              
                <div class="image-wrapper" *ngIf="nicFrontPreview">
                  <img [src]="nicFrontPreview" class="img-preview" />
              
                  <span class="remove-icon" (click)="removeNicFront()">
                    &times;
                  </span>
                </div>
              </div>
              
              <div class="mb-4 position-relative nic-upload">
                <label class="form-label">{{ 'MODALS.REGISTRATION.NIC_BACK_IMG' | translate }}</label>
              
                <input
                  #nicBackInput
                  type="file"
                  accept="image/*"
                  capture="environment"
                  class="form-control"
                  hidden
                  (change)="onNicBackSelected($event)"
                />

                <div
                  class="camera-box"
                  *ngIf="!nicBackPreview"
                  (click)="nicBackInput.click()"
                >
                  <ion-icon name="camera"></ion-icon>
                  <span style="text-align: center;">{{ 'MODALS.REGISTRATION.UPLOAD_NIC_BACK' | translate }}</span>
                </div>

                <div class="text-danger error"
                    *ngIf="regform.get('nicBack')?.invalid && regform.get('nicBack')?.touched">
                    {{'FORM_ERR.NIC_BACK' | translate}}
                </div>

                <div class="text-danger error"
                    *ngIf="regform.get('nicBack')?.hasError('conversionFailed') &&
                            regform.get('nicBack')?.touched">
                  {{ 'FORM_ERR.NIC_IMAGE_CONVERSION' | translate }}
                </div>
              
                <div class="image-wrapper" *ngIf="nicBackPreview">
                  <img [src]="nicBackPreview" class="img-preview" />
              
                  <span class="remove-icon" (click)="removeNicBack()">
                    &times;
                  </span>
                </div>
              </div>               -->

              <button [disabled]="errorControl.nic.errors || errorControl.fname.errors || errorControl.sname.errors" type="buttons" class="btn btn-primary btn-block" (click)="goto_step2()">{{ 'MODALS.REGISTRATION.NEXT' |
                translate }}: {{ 'MODALS.REGISTRATION.ADDRESS_INFO' | translate }}</button><br>
            </div>
            <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
            <button (click)="dismiss()" type="link" class="close">
              <span class="icon icon-close"></span>
            </button>
          </form>
        </div>

        <!-- step 2 -->
        <div class="register-modal-form" *ngIf="step2">
          <form [formGroup]="regform2"  >
          <div class="text-center">
            <h4 class="t-h4 t-medium">{{ 'MODALS.REGISTRATION.TITLE' | translate }}</h4>
            <div class="t t-small">{{ 'MODALS.REGISTRATION.STEP2-TITILE' | translate }}</div>
          </div>
          <div class="mt-4 text-left">

            
            
            <div class="mb-3">
              <label for="register_surname" class="form-label">{{ 'MODALS.REGISTRATION.STREET-NO' | translate }}</label>
              <input type="text" formControlName="address1" class="form-control" [(ngModel)]="address1"
                placeholder="{{'PLACEHOLDERS.STREET_NO' | translate}}"  />
                
                <span class="text-danger error " *ngIf="errorControl2.address1.errors?.required && (errorControl2.address1.dirty || errorControl2.address1.touched)">
                  {{'FORM_ERR.STREET_REQ' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl2.address1.errors?.minlength">
                  {{'FORM_ERR.FNAME_MIN' | translate}}
                </span>
            </div>
            <div class="mb-4">
              <label for="register_nic" class="form-label">{{ 'MODALS.REGISTRATION.STREET-NAME' | translate }}</label>
              <input type="text" formControlName="address2" class="form-control" [(ngModel)]="address2" placeholder="{{'PLACEHOLDERS.STREET_NAME' | translate}}" />

              <span class="text-danger error " *ngIf="errorControl2.address2.errors?.required && (errorControl2.address2.dirty || errorControl2.address2.touched)">
                {{'FORM_ERR.STREET_NAME_REQ' | translate}}
              </span>
              <span class="text-danger error " *ngIf="errorControl2.address2.errors?.minlength">
                {{'FORM_ERR.FNAME_MIN' | translate}}
              </span>
            </div>
            
            <div class="mb-3">
              <label for="register_surname" class="form-label">{{ 'MODALS.REGISTRATION.TOWN' | translate }}</label>
              <input type="text" formControlName="suburb" class="form-control" [(ngModel)]="suburb"
                placeholder="{{'PLACEHOLDERS.TOWN' | translate}}" />

                <span class="text-danger error " *ngIf="errorControl2.suburb.errors?.required && (errorControl2.suburb.dirty || errorControl2.suburb.touched)">
                  {{'FORM_ERR.TOWN_REQ' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl2.suburb.errors?.minlength">
                  {{'FORM_ERR.FNAME_MIN' | translate}}
                </span>
            </div>
            <!-- <div class="mb-4">
              <label for="register_nic" class="form-label">{{ 'MODALS.REGISTRATION.POSTAL-CODE' | translate }}</label>
              <input ng-minlength=5 ng-maxlength=5 type="text" formControlName="zip" class="form-control" placeholder="{{'PLACEHOLDERS.ZIP' | translate}}" [(ngModel)]="postalCode" />

              <span class="text-danger error " *ngIf="errorControl2.zip.errors?.required && (errorControl2.zip.dirty || errorControl2.zip.touched)">
                {{'FORM_ERR.ZIP_REQ' | translate}}
              </span>
              <span class="text-danger error " *ngIf="errorControl2.zip.errors?.maxlength || errorControl2.zip.errors?.minlength">
                {{'FORM_ERR.ZIP_MIN' | translate}}
              </span>

            </div> -->
            <button type="buttons" [disabled]="errorControl2.address1.errors || errorControl2.address2.errors || errorControl2.suburb.errors" class="btn btn-primary btn-block" (click)="goto_step3()" >{{ 'MODALS.REGISTRATION.STEP3-TITLE' | translate }}</button>
            <br>
          </div>
          <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
          <button (click)="dismiss()" type="link" class="close">
            <span class="icon icon-close"></span>
          </button>

          </form>
        </div>

        <!-- step 3 -->
        <div class="register-modal-form" *ngIf="step3">
          <form [formGroup]="regform3" (ngSubmit)="goto_step4()" >
          <div class="text-center">
            <h4 class="t-h4 t-medium">{{ 'MODALS.REGISTRATION.TITLE' | translate }}</h4>
            <div class="t t-small">{{ 'MODALS.REGISTRATION.STEP3-TITLE' | translate }}</div>
          </div>
          <div class="mt-4 text-left">
            
            <span class="valid-email-text text-danger error">Please enter valid Email address as this will be used to activate your account</span>
            <div class="mb-3">
              <label for="register_surname" class="form-label">{{ 'MODALS.REGISTRATION.EMAIL' | translate }}</label>
              <input formControlName="email" type="text"  class="form-control" [(ngModel)]="email"
                placeholder="{{'PLACEHOLDERS.EMAIL' | translate}}" />

                <span class="text-danger error " *ngIf="errorControl3.email.errors?.required && (errorControl3.email.dirty || errorControl3.email.touched)">
                  {{'FORM_ERR.EMAIL_REQ' | translate}}
                </span>
                <span class="text-danger error " *ngIf="errorControl3.email.errors?.pattern">
                  {{'FORM_ERR.EMAIL_INV' | translate}}
                </span>

            </div>
            <div class="mb-4">
              <label for="register_nic" class="form-label">{{ 'COMMON.PHONE_NO' | translate }}</label>
              <input formControlName="phone" type="text"  class="form-control" placeholder="{{'PLACEHOLDERS.TEL' | translate}}" [(ngModel)]="phoneNumber" />
              <span class="text-danger error " *ngIf="errorControl3.phone.errors?.required && (errorControl3.phone.dirty || errorControl3.phone.touched)">
                {{'FORM_ERR.TEL_REQ' | translate}}
              </span>
              <span class="text-danger error " *ngIf="errorControl3.phone.errors?.maxlength || errorControl3.phone.errors?.minlength || errorControl3.phone.errors?.pattern">
                {{'FORM_ERR.TEL_MIN' | translate}}
              </span>
              
            </div>
                   
            <button type="buttons" [disabled]="errorControl3.email.errors || errorControl3.phone.errors" class="btn btn-primary btn-block" (click)="goto_step4()" >{{ 'MODALS.REGISTRATION.STEP4-TITLE' | translate }}</button>
            <br>
          </div>
          <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
          <button (click)="dismiss()" type="link" class="close">
            <span class="icon icon-close"></span>
          </button>
        </form>
        </div>


        <!-- step 4 -->
        <div class="register-modal-form" *ngIf="step4">
          <div class="text-center">
            <h4 class="t-h4 t-medium">{{ 'MODALS.REGISTRATION.NEW-USER-REGISTRATION' | translate }}</h4>
            <div class="t t-small">{{ 'MODALS.REGISTRATION.STEP4-TITLE' | translate }}</div>
          </div>

          <div class="mt-4 row gy-4 text-left t-small">
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.NAME' | translate }}</div>
              <div class=" t-strong">{{title+" "+firstName+" "+surname}}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.COUNT-OF-ORGIN' | translate }}</div>
              <div class=" t-strong">{{ 'MODALS.REGISTRATION.COUNTRY_SRILANKA' | translate }}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.EMAIL-ADDRESS' | translate }}</div>
              <div class=" t-strong">{{email}}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.ADDRESS' | translate }}</div>
              <div class=" t-strong">{{address1+" "+address2}}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.NIC-NUMBER' | translate }}</div>
              <div class=" t-strong">{{idNumber}}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.TOWN' | translate }}</div>
              <div class=" t-strong">{{suburb}}</div>
            </div>
            <div class="col-6">
              <div class="">{{ 'COMMON.PHONE_NO' | translate }}</div>
              <div class=" t-strong">{{phoneNumber}}</div>
            </div>
            <!-- <div class="col-6">
              <div class="">{{ 'MODALS.REGISTRATION.POSTAL-CODE' | translate }}</div>
              <div class=" t-strong">{{postalCode}}</div>
            </div> -->
          </div>

          <div class="mt-4 mb-4">
            <div class="form-check text-left">
              <input class="form-check-input" [(ngModel)]="agreeToTerms" type="checkbox"  id="flexCheckDefault" >
              <label class="form-check-label" for="flexCheckDefault">
                            {{'PLACEHOLDERS.AGREE1' | translate}} <a class="text-primary" (click)="launchBookOfRules()"  >{{'PLACEHOLDERS.AGREE2' | translate}}</a>
              </label>
            </div>
          </div>

          <button class="btn btn-primary btn-block" [disabled]="!agreeToTerms"  (click)="click_register()">{{ 'MODALS.REGISTRATION.COMPLETE-REGISTER' | translate }}</button> <br>

          <!-- <ion-icon class="close icon icon-close" (click)="dismiss()" name="close-sharp"></ion-icon> -->
          <button (click)="dismiss()" type="link" class="close">
            <span class="icon icon-close"></span>
          </button>
          
        </div>


        <div class="mt-4 text-center">
        {{ 'MODALS.REGISTRATION.QUESTION_1' | translate }} <a class="active" (click)="launchLogin()">{{ 'MODALS.REGISTRATION.LOGIN' | translate }}</a> {{ 'MODALS.REGISTRATION.OR' | translate }} <a class="active" (click)="resetPassword()">{{ 'MODALS.REGISTRATION.RESET_PW' | translate }}</a>
        </div>
      </div>
    </div>
  </div>

</div>


